// @flow
import { CollectionUnreadCountEntry } from '../../autogenerated/ZoomBridge';

export default class UnreadCommentsData {
  static NAME = 'UnreadCommentsData';
  unreadCommentCount: number;
  collectionUnreadCountEntries: CollectionUnreadCountEntry[];

  constructor() {
    this.unreadCommentCount = 0;
    this.collectionUnreadCountEntries = [];
  }

  getUnreadCommentCount() {
    return this.unreadCommentCount;
  }

  getCollectionUnreadCountEntries() {
    return this.collectionUnreadCountEntries;
  }

  setUnreadCommentCount(unreadCommentCount: number) {
    this.unreadCommentCount = unreadCommentCount;
    return this;
  }

  setCollectionUnreadCountEntries(collectionUnreadCountEntries: CollectionUnreadCountEntry[]) {
    this.collectionUnreadCountEntries = collectionUnreadCountEntries;
    return this;
  }

  equals(other: UnreadCommentsData): boolean {
    if (this.unreadCommentCount !== other.unreadCommentCount) {
      return false;
    }

    const a = JSON.stringify(this.collectionUnreadCountEntries.map((e) => e.serializeJson()));
    const b = JSON.stringify(other.collectionUnreadCountEntries.map((e) => e.serializeJson()));

    return a === b;
  }
}
